import { GET_FEATURE_FLAGS, UPDATE_FEATURE_FLAGS } from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
    featureFlags: []
};

// REDUCER
export const FeatureFlagsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_FEATURE_FLAGS: {
            var featureFlags
            try {
                featureFlags = JSON.stringify(action.payload, null, 4);
            } catch (error) {
                featureFlags = error
            }

            return {
                ...state,
                featureFlags
            }
        }

        case UPDATE_FEATURE_FLAGS: {
            return {
                ...state,
            }
        }

        default:
            return state;
    }
};